import { CLIENT_PROFILE_COMPONENT_TYPES, COMPONENT_TYPES, staticRoutes } from '@atlas/routing';

const {
  All_PROVIDERS,
  BLOG,
  CASINO,
  CASINO_LIVE,
  CLIENT_PROFILE,
  LUCKY_DAY,
  MENU,
  PROMOTION_TOURNAMENTS,
  PROMOTIONS,
  RESULTS,
  SMARTICO_MISSIONS,
  SMARTICO_STORE,
  SPORT_LIVE,
  SPORT_PREMATCH,
  TOURNAMENTS,
  TV_GAMES,
  VIRTUAL_GAME,
} = COMPONENT_TYPES;

const { MESSAGES, PROMO_CODES } = CLIENT_PROFILE_COMPONENT_TYPES;

/**
 * Canonical Smartico Store component type, re-exported for store-page code and
 * entry-point wiring. `SMARTICO_STORE` ('smarticoStore') is a first-class
 * `@atlas/routing` `COMPONENT_TYPES` value whose canonical path is
 * `staticRoutes.smarticoStore` ('/account/store', matching akira). On mobile the
 * page renders STANDALONE (no Client Profile chrome) via an explicit route in
 * `MainRouter.js`, so it is intentionally NOT listed in `availableGeneralRoutes`
 * below. It is still registered in `SiteConfigManager.setLayoutConfig(...)`
 * (`mobile/src/modules/index.js`) so `getComponentPath(SMARTICO_STORE)` resolves
 * for entry points (lobby block, navigation).
 */
export { SMARTICO_STORE };

export const availableGeneralRoutes = {
  [All_PROVIDERS]: {},
  [BLOG]: {},
  [CASINO]: {},
  [CASINO_LIVE]: {},
  [CLIENT_PROFILE]: {},
  [LUCKY_DAY]: {},
  [MENU]: {},
  [MESSAGES]: {},
  [PROMOTIONS]: {},
  [PROMOTION_TOURNAMENTS]: {},
  [PROMO_CODES]: {},
  [RESULTS]: {},
  [SMARTICO_MISSIONS]: {},
  [SPORT_LIVE]: {},
  [SPORT_PREMATCH]: {},
  [TOURNAMENTS]: {},
  [TV_GAMES]: {},
  [VIRTUAL_GAME]: {},
  forgotPassword: {},
  pages: {},
  resetPassword: {},
  settings: {},
  signin: {},
  signup: {},
};

export const defaultRoutes = {
  signin: '/signin',
  signup: '/signup',
  forgotPassword: '/forgotPassword',
  resetPassword: '/resetPassword',
  account: '/account',
  messages: '/account/messages',
  casino: '/casino',
  sportLive: '/live',
  menu: '/menu',
  settings: '/settings',
  sportPrematch: '/sportsbook',
  results: '/results',
  tvGames: '/betgames',
  casinoLive: '/live-casino',
  promotions: '/promotions',
  blog: '/blog',
  promotionTournaments: '/promotion-tournaments',
  staticPage: '/page/:slug',
  virtualGame: '/virtual-game',
  notFound: 'notFound',
  allProvidersPage: '/game-providers',
  smarticoMissions: '/smartico-missions',
  // Canonical Smartico Store route path (`staticRoutes.smarticoStore` = '/account/store').
  [SMARTICO_STORE]: staticRoutes.smarticoStore,
};
